import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss'],
})
export class ConfirmDeleteComponent {
  message: string;
  title: string;
  positive: string;
  negative: string;

  constructor(public modal: NgbActiveModal) {}

  setModalProperties(properties: any): any {
    this.title = properties.title || '';
    this.message = properties.message || '';
    this.positive = properties.buttons.positive || '';
    this.negative = properties.buttons.negative || '';
  }

  onActionTake(response: boolean): any {
    this.modal.close(JSON.stringify(response));
  }
}
